module.exports = __webpack_public_path__ + "20260611d121505t/img/pic_tongyongweikong@2x.987159ac.png";